import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AppBarThree } from './components/AppBar';
import Footer from './components/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import { ButtonView } from '../components/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import { MagicStar, HeartTick, Quant, Tag2 } from 'iconsax-react';
import Carousal from './components/Carousal';
import { HomeProductsOne } from './HomeProducts';
import Countdown from './components/DayCount';
import MetaTags from './components/MetaTags';

const Home = () => {
  useEffect(() => {
    AOS.init({
      offset: 80,
      duration: 1000,
      easing: 'ease-out-cubic',
      once: true,
    });
  }, []);

  const navigate = useNavigate();
  const handlenavigate = () => {
    navigate('/');
  };

  return (
    <>
      <MetaTags
        title="Alagar Crackers | Sivakasi Crackers Wholesale & Retail Store"
        type="website"
        siteName="alagarcrackers.com"
        url="https://alagarcrackers.com/home"
        keywords="Alagar Crackers, Sivakasi Crackers, Wholesale Crackers, Diwali Crackers, Sparklers, Fireworks Sivakasi"
        description="Buy authentic Sivakasi Crackers directly from Alagar Crackers at lowest wholesale prices. 200+ varieties available."
        revisitAfter="10 Days"
      />
      <div className='over'>
        <AppBarThree />

        {/* Hero Banner */}
        <div className='position-relative'>
          <img
            src={require("../assets/images/banner/banner_nine.jpg")}
            className="img-fluid w-100"
            alt="Alagar Crackers Diwali Sale"
          />
          <div className='position-absolute bottom-0 start-50 translate-middle-x mb-3 d-none d-md-block'>
            <Countdown />
          </div>
        </div>

        {/* Mobile Countdown Strip */}
        <div className='d-md-none text-center py-2 bg-light'>
          <Countdown />
        </div>

        {/* Welcome Section */}
        <div className='padding'>
          <Container>
            <Row className='align-items-center g-4'>
              <Col lg={6} xs={12}>
                <div className='home-top pe-lg-4'>
                  <div className='d-inline-block px-3 py-1 bg-danger bg-opacity-10 text-danger rounded-pill fw-bold mb-3' style={{ fontSize: '13px' }}>
                    🎇 SIVAKASI DIRECT WHOLESALE SHOP
                  </div>
                  <h1 className='bold color-red mb-3' style={{ fontSize: '2.5rem', lineHeight: 1.2 }}>
                    Welcome to Alagar Crackers
                  </h1>
                  <div className='regular text-muted' style={{ fontSize: '16px', lineHeight: 1.8 }}>
                    <p>
                      <strong>Alagar Crackers</strong> is one of the premier direct suppliers of authentic Sivakasi fireworks, sparklers, fancy sky shots, and festive gift boxes. Our dedication is to bring the magical sounds, colors, and sparkles of Sivakasi right to your doorsteps at unbeatable wholesale rates.
                    </p>
                    <p>
                      With over 200 varieties of high-grade fireworks developed and certified for safety, our products bring dazzling joy to families and celebrations across India.
                    </p>
                  </div>

                  <div className='mt-4'>
                    <ButtonView label={<>🔥 Explore Price List & Order Now</>} className="shop-now" onClick={handlenavigate} />
                  </div>
                </div>
              </Col>
              <Col lg={6} xs={12} className='text-center'>
                <div className='p-2 bg-white rounded-4 shadow-sm border'>
                  <img
                    src={require('../assets/images/intro.jpg')}
                    className='img-fluid rounded-3'
                    alt='Best discount in Diwali sale'
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Category Products Showcase */}
        <HomeProductsOne />

        {/* Festive Blast Animation Elements */}
        <div className='blast-one'>
          <img src={require('../assets/images/blast_one.gif')} className='img-fluid' alt='Blast Crackers' />
        </div>
        <div className='blast-two'>
          <img src={require('../assets/images/blast_two.gif')} className='img-fluid' alt='Blast Crackers' />
        </div>

        {/* Introduction Section */}
        <div className='padding' style={{ backgroundColor: '#fff9f8' }}>
          <Container>
            <Row className='justify-content-center'>
              <Col lg={10} xs={12} className='text-center'>
                <div className='d-inline-block px-3 py-1 bg-danger bg-opacity-10 text-danger rounded-pill fw-bold mb-3' style={{ fontSize: '13px' }}>
                  ⭐ TRUSTED FOR OVER 10+ YEARS
                </div>
                <h2 className='bold lg-font h1color mb-4'>
                  Diwali Best Crackers in Sivakasi
                </h2>
                <div className='regular text-muted' style={{ fontSize: '16.5px', lineHeight: 1.9 }}>
                  <p>
                    We welcome you to experience our mega fireworks showroom and online ordering portal directly from Sivakasi. Place your valuable orders and fulfill all your family and corporate fireworks requirements in one convenient stop.
                  </p>
                  <p>
                    From dazzling Sparklers, Ground Chakkars, and vibrant Flower Pots to Multi-Color Shots, Aerial Novelties, Sound Crackers, and custom Gift Boxes — we provide only standard, authorized, and top-tier products.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <img src={require('../assets/images/banner/banner_et.jpg')} className='img-fluid w-100' alt='Alagar Crackers Celebration' />

        {/* Why Choose Section */}
        <div className='padding bg-white'>
          <Container>
            <Row className='justify-content-center mb-5'>
              <Col lg='8' className='text-center'>
                <h2 className='bold lg-font h1color mb-3'>Why Choose Alagar Crackers?</h2>
                <p className='regular text-muted' style={{ fontSize: '16px' }}>
                  Authentic Sivakasi crackers manufactured under strict safety guidelines, guaranteed factory direct prices, and hassle-free delivery.
                </p>
              </Col>
            </Row>
            <Row className='g-4'>
              <Col lg="3" sm="6" xs={12}>
                <div className='why-box-one'>
                  <div className='box-icon mb-3' style={{ width: '56px', height: '56px' }}>
                    <Quant size="28" color="#d90429" />
                  </div>
                  <h5 className='bold text-dark'>Top Quality</h5>
                  <p className='regular text-muted text-center small mb-0'>
                    100% legal, certified materials with vibrant colors and reliable timing.
                  </p>
                </div>
              </Col>
              <Col lg="3" sm="6" xs={12}>
                <div className='why-box-two'>
                  <div className='box-icon mb-3' style={{ width: '56px', height: '56px' }}>
                    <Tag2 size="28" color="#d90429" />
                  </div>
                  <h5 className='bold text-dark'>Wholesale Prices</h5>
                  <p className='regular text-muted text-center small mb-0'>
                    Factory direct pricing with flat discounts on 200+ varieties.
                  </p>
                </div>
              </Col>
              <Col lg="3" sm="6" xs={12}>
                <div className='why-box-one'>
                  <div className='box-icon mb-3' style={{ width: '56px', height: '56px' }}>
                    <MagicStar size="28" color="#d90429" />
                  </div>
                  <h5 className='bold text-dark'>Safe to Use</h5>
                  <p className='regular text-muted text-center small mb-0'>
                    Tested for safety, stable flight, and minimal hazardous smoke.
                  </p>
                </div>
              </Col>
              <Col lg="3" sm="6" xs={12}>
                <div className='why-box-two'>
                  <div className='box-icon mb-3' style={{ width: '56px', height: '56px' }}>
                    <HeartTick size="28" color="#d90429" />
                  </div>
                  <h5 className='bold text-dark'>100% Satisfaction</h5>
                  <p className='regular text-muted text-center small mb-0'>
                    Trusted by 10,000+ happy customers with dedicated support.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Stats Parallax Counter */}
        <div className='counter padding bg-overlay z'>
          <Container className='z'>
            <Row className='text-center g-4'>
              <Col lg="3" xs={6}>
                <div className='counter-box'>
                  <CountUp end={10} duration={3} /><span>+</span>
                </div>
                <div className='bold text-white'>Years of Trust</div>
              </Col>
              <Col lg="3" xs={6}>
                <div className='counter-box'>
                  <CountUp end={200} duration={3} /><span>+</span>
                </div>
                <div className='bold text-white'>Cracker Varieties</div>
              </Col>
              <Col lg="3" xs={6}>
                <div className='counter-box'>
                  <CountUp end={10000} duration={3} /><span>+</span>
                </div>
                <div className='bold text-white'>Happy Families</div>
              </Col>
              <Col lg="3" xs={6}>
                <div className='counter-box'>
                  <CountUp end={100} duration={3} /><span>%</span>
                </div>
                <div className='bold text-white'>Quality Assurance</div>
              </Col>
            </Row>
          </Container>
        </div>

        <img src={require('../assets/images/banner/baanner7.jpg')} className='img-fluid w-100' alt='Alagar Crackers Sivakasi' />

        {/* Wholesale & Retail Banners */}
        <div className='padding bg-white'>
          <Container>
            <Row className='g-4'>
              <Col lg="6" xs={12}>
                <div className='rounded-4 overflow-hidden shadow-sm'>
                  <img src={require('../assets/images/wholesale_retails/aboutimage1.webp')} className='img-fluid w-100' alt='Retail Crackers' />
                </div>
              </Col>
              <Col lg="6" xs={12}>
                <div className='rounded-4 overflow-hidden shadow-sm'>
                  <img src={require('../assets/images/wholesale_retails/aboutimage2.webp')} className='img-fluid w-100' alt='Wholesale Crackers' />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Brand Partners */}
        <div className='padding' style={{ backgroundColor: '#f8fafc' }}>
          <Container>
            <Row className='justify-content-center'>
              <Col lg="12" className='text-center mb-4'>
                <h2 className='bold color-red'>Our Partner Brands</h2>
                <p className='regular text-muted'>We distribute authorized Sivakasi fireworks from trusted brands.</p>
              </Col>
              <Col lg="10" xs={12} className='text-center'>
                <Carousal />
              </Col>
            </Row>
          </Container>
        </div>

        {/* Bottom Callout Banner */}
        <div className='salebg'>
          <Container>
            <Row className='align-items-center g-4'>
              <Col lg="7" xs={12}>
                <h2 className='bold text-white mb-3' style={{ fontSize: '2.4rem' }}>
                  Get Your Festival Crackers at Direct Factory Rates!
                </h2>
                <div className='regular text-white-50 mb-4' style={{ fontSize: '16.5px', lineHeight: 1.8 }}>
                  <p>
                    Why pay high market prices? Buy directly from our Sivakasi godown and save up to 80% with our flat wholesale festival discounts.
                  </p>
                </div>
                <ButtonView label={<>🔥 Order Your Crackers Now</>} className="shop-now" onClick={handlenavigate} />
              </Col>
              <Col lg="5" xs={12} className='text-center'>
                <img src={require('../assets/images/gify.webp')} className='img-fluid' style={{ maxHeight: '260px' }} alt='Celebrate Diwali' />
              </Col>
            </Row>
          </Container>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Home;